import { render, staticRenderFns } from "./CutSheetViewer.vue?vue&type=template&id=63d884e6&scoped=true"
import script from "./CutSheetViewer.vue?vue&type=script&lang=js"
export * from "./CutSheetViewer.vue?vue&type=script&lang=js"
import style0 from "./CutSheetViewer.vue?vue&type=style&index=0&id=63d884e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d884e6",
  null
  
)

export default component.exports